

































































import Vue from "vue";
import Hand from "./Hand.vue";
import Displayed from "./Displayed.vue";
import { TileNameMap, UniqueTile } from "../models/tile";

export default Vue.extend({
  name: "Player",
  props: ["info", "player_turn", "player_number", "transiting", "turnNumber"],
  components: {
    Hand,
    Displayed
  },
  data() {
    return {
      dialog: false,
      drawDisabled: false,
      lastPlayerTurn: -1,
    };
  },
  updated() {
    // 3rd boolean condition ensures only 1 block per game turn
    if (this.transiting && this.player_turn === this.player_number && this.lastPlayerTurn !== this.turnNumber) {
      console.log(`trigger block on draw for turn ${this.turnNumber}`)
      this.lastPlayerTurn = this.turnNumber; // trigger only on first instance of update each turn
      this.drawDisabled = true;
      // set draw button to clickable
      const fn = () => {
        this.drawDisabled = false;
      }

      setTimeout(function() {
        fn();
      }, 3000);
    }
  },
  computed: {
    lastDrawnTile(): number {
      return this.info.last_drawn_tile ? this.info.last_drawn_tile : -1
    },
    possibleGone(): number[][] {
      return this.info.inner_gong_map.filter((l: number[]) => {
        l.length === 4;
      });
    }
  },
  methods: {
    emitMove(event: object) {
      if (this.player_number === this.player_turn && !this.transiting) {
        this.$emit(
          "move",
          Object.assign(event, { player: this.player_number })
        );
      }
    },
    emitInterruptMove(action: number) {
      this.$emit("imove", { action: action, player: this.player_number });
      this.dialog = false;
    },
    innerGongTile(name: number): UniqueTile {
      return TileNameMap[name];
    },
    emitInnerGong(action: number, id: string) {
      this.$emit("move", {
        player: this.player_number,
        action: action,
        tile: id
      });
    }
  }
});
